export default __webpack_public_path__ + "static/media/fuse.bb6e2bf4.svg";